import React, { Component } from "react";
import { encryptData } from "./utils/encryptionUtils";
import { getClientId } from "./utils/analyticsclientIdUtils";
import ZPartner02Header from "./ZPartner02Header";
import ZPartner02Footer from "./ZPartner02Footer";

export class ZPartner02MemberNew extends Component {
    static displayName = ZPartner02MemberNew.name;

    constructor(props) {
        super(props);
        this.state = {
            email: "",
            requireMsgEmail: "",
            submitting: false,
            refUserId: "",
            switchBackUrl: "",
            jcheck: ""
        };
    }

    componentDidMount() {
        const links = [
            "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
            "/css/style.css",
            "/css/style-sr.css"
        ];

        links.forEach(href => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        });

        // Google Analytics / GTM tracking (same idea as EnAuthSignin)
        const documentPath = "Partner02_MemberNew_Step01";
        const clientId = getClientId();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "pageview",
            page: documentPath,
            clientId: clientId
        });

        // #region "back button / history handling"
        if (typeof window !== "undefined" && window.history && window.history.pushState) {
            window.history.pushState(null, "", window.location.href);

            this.handlePopState = (event) => {
                window.history.pushState(null, "", window.location.href);
            };

            window.addEventListener("popstate", this.handlePopState);
        }
        // #endregion

        // Read parameters
        const { refUserId, switchBackUrl } = this.props.location.state || {};

        // If any required parameter is missing, redirect to error page
        if (!refUserId || !switchBackUrl) {
            window.location.replace("/x02lineman/Error?S=param");
        }

        // Save values into state
        this.setState({ refUserId, switchBackUrl, jcheck: "done" });
    }

    componentWillUnmount() {
        // clear listener when exit component (prevent memory leak)
        if (this.handlePopState) {
            window.removeEventListener("popstate", this.handlePopState);
        }
    }    

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    // Email validation
    validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        const { email, refUserId, switchBackUrl } = this.state;

        let canSubmit = true;

        // Reset messages
        this.setState({
            requireMsgEmail: "",
        });

        // Validate email
        if (!email) {
            this.setState({ requireMsgEmail: "Enter an email" });
            canSubmit = false;
        } else if (!this.validateEmail(email)) {
            this.setState({ requireMsgEmail: "Please enter valid Email" });
            canSubmit = false;
        }

        if (!canSubmit) {
            return;
        }

        // Prevent double submit
        this.setState({ submitting: true });
        document.body.classList.add("wait-cursor");

        const timestamp = Math.floor(Date.now() / 1000);

        // Payload for Line Signin
        const payload = {
            Email: email,
            refUserId: refUserId,
            switchBackUrl: switchBackUrl,
            partnerCode: "002",
            Timestamp: timestamp
        };

        const encryptedPayload = encryptData(payload);

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/ZPartnerLinkByNewStep01`, requestOptions);
            const data = await response.json();
            document.body.classList.remove("wait-cursor");
            console.log(data);
            if (data.responseCode === "00") {
                const message = (data.responseMessage || "").toLowerCase();
                document.body.classList.remove("wait-cursor");

                // Redirect after successful signin
                switch (message) {
                    case "success":
                        window.location.replace("/x02lineman/MemberNewThx");
                        break;
                    case "successwithnotsendmail":
                        window.location.replace("/x02lineman/MemberNewThx/?case=1");
                        break;
                    case "error-newregisemaildup":
                        window.location.replace("/x02lineman/Error?S=newregisemaildup");
                        break;                    
                    default:
                        window.location.replace("/x02lineman/MemberNewThx/?case=2");
                        break;
                }
            }
            else {
                window.location.replace("/x02lineman/MemberNewThx/?case=3");
            }
        } catch (error) {
            window.location.replace("/x02lineman/MemberNewThx/?case=4");
        }
    };

    render() {
        const { refUserId, switchBackUrl, jcheck, email, submitting, requireMsgEmail } = this.state || {};

        if (jcheck !== "done") {
            return (
                <div className="text-center mt-5 pt-5 mb-5 pb-5">
                    <h3 className="text-black">LOADING ...</h3>
                    <img src="media/loading-gif.gif" alt="Loading..." width={80} className="img-fluid" />
                </div>
            );
        }

        return (
            <>
                <ZPartner02Header />

                {/* Start Content */}
                <main id="main">
                    <section className="top-sr-bg bg-gray1">
                        <div className="container">
                            <div className="row justify-content-between">
                                <div className="col col-md-6">
                                    <h1 className="text-headpage text-white mb-0 pt-3 pb-3 ">
                                        <span className="d-none">Starbucks® Rewards</span><img src="media/rewards/starbucks-rewards-logo-2.png" alt="Starbucks® Rewards" className="img-fluid" style={{ maxWidth: '158px' }} />
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">
                            <div className="row">
                                <div className="col-md-12 mb-5 pt-3 p-4 text-center">
                                    <h2 className="h3 mt-5 mb-4 fw-bold text-dark-212121">ลงทะเบียน<br />
                                        Create an account</h2>
                                    <p>สตาร์บัคส์ รีวอร์ด <br />
                                        Starbucks® Rewards</p>
                                    <p>ร่วมเป็นสมาชิก สตาร์บัคส์ รีวอร์ด เพื่อรับสิทธิประโยชน์สำหรับสมาชิกโดยเฉพาะ เพิ่มความสะดวกในการใช้จ่ายผ่าน Starbucks® TH app และอื่นๆ อีกมากมาย</p>
                                    <p>Join Starbucks® Rewards to earn Stars, get access to Rewards and more.</p>
                                </div>
                            </div>
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3">
                                    <div className="py-5 p-4 box-sign-in">
                                        <form className="form-sr px-1 px-md-4" onSubmit={this.handleSubmit}>
                                            <div className="mb-4">
                                                <label htmlFor="exampleInputEmail1" className="form-label">* ลิงก์ยืนยันจะถูกส่งไปยังอีเมลนี้ /<br />
                                                    A verification link will be sent to this email</label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="อีเมล / Email"
                                                    name="email"
                                                    value={email}
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">{requireMsgEmail}</span>
                                            </div>
                                            <div className="text-center">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary rounded-pill px-4 w-100"
                                                    disabled={submitting}
                                                >
                                                    <span className="text-sm Sarabun_fontthai text-bold">
                                                        {submitting ? "ลงทะเบียน..." : "ลงทะเบียน"}
                                                    </span>
                                                    <br />
                                                    <span className="text-xxs text-bold">
                                                        {submitting ? "Create account..." : "Create account"}
                                                    </span>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<div style={{ marginTop: 24 }}>*/}
                        {/*    <small>*/}
                        {/*        Debug: Ref01 = {refUserId || "(empty)"} <br />*/}
                        {/*        ref02 = {switchBackUrl || "(empty)"}*/}
                        {/*    </small>*/}
                        {/*</div>*/}
                    </section>
                </main>
                {/* End Content */}

                <ZPartner02Footer />
            </>
        );
    }
}
